import { Component, OnInit, Input, NgZone, Output, EventEmitter } from '@angular/core';
import { BaseComponent } from '../classes/BaseComponent';
import { ValidationHelper } from '../helpers/ValidationHelper';
import { AuthenticationService } from '../authentication.service';
import { Global } from '../classes/Global';
import { Facebook } from '../classes/Facebook';
import { InternationalizationHelper } from '../helpers/InternationalizationHelper';
import { Router } from '@angular/router';
import { Log } from '../helpers/Log';
import { StorageHelper } from '../helpers/StorageHelper';

@Component({
  selector: 'app-register-username',
  templateUrl: './register-username.component.html',
  styleUrls: ['./register-username.component.scss'],
  providers: [ AuthenticationService ]
})
export class RegisterUsernameComponent extends BaseComponent implements OnInit {

  username = "";
  @Input() referralCode: string = "";
  facebook: Facebook = Facebook.getInstance();
  success = true;
  serverError = false;
  serverErrorMessage = "";
  @Input() facebookResponse;
  @Output() onRegisterSuccess = new EventEmitter();
  privacyPolicyError = false;
  invalidUsername = false;

  referralCodeInputDisabled: boolean = false;

  constructor(
    private authenticationService: AuthenticationService,
    private router: Router,
    private zone: NgZone) {
    super();
  }

  ngOnInit() {
    if(this.referralCode) {
      this.referralCodeInputDisabled = true;
    }
  }

  onReferralCodeChange(code: string) {
    this.referralCode = code;
  }

  onUsernameChange(username) {
    this.username = username;
  }

  register() {

    this.privacyPolicyError = false;
    if (document.getElementById("privacyPolicyCheckbox")["checked"] === false) {
      this.privacyPolicyError = true;
      return;
    }

    if (!ValidationHelper.isValidUsername(this.username)) {
      this.invalidUsername = true;
    }
    else if (this.facebookResponse) {

      const self = this;

      this.facebook.getFBRef().api('/me', { locale: InternationalizationHelper.getLanguage(), fields: 'id,name,picture,email' },
      function(graphAPIResponse) {

        if (graphAPIResponse.email) {
          self.authenticationService.registerByFb(Global.getCountry(), graphAPIResponse.email,
          self.facebookResponse.authResponse.userID, self.username, Global.getStore(), self.referralCode)
          .subscribe(res => {
            //run with zone because the facebook API does not work with observables and
            //otherwise Angular does not refresh the UI until a click is done
            self.zone.run(() => {
              self.handleResult(res);
            });
          }, err => {
            self.zone.run(() => {
              self.handleError(err);
            });
          });
        }
        else {
          //The email of the user is missing
          self.serverError = true;
          self.serverErrorMessage = self.getString('fbUserEmailIsMissing');
        }

      });

    }
    else {
      //no response from facebook
      this.serverError = true;
      this.serverErrorMessage = this.getString('noResponseFromFacebook');
    }
  }

  handleResult(result) {
    if (result && result.status === "success") {
      this.onRegisterSuccess.emit();
      //clear saved invite code if one was used
      if(this.referralCode) {
        StorageHelper.getInstance().clear(StorageHelper.keys.inviteCode);
        StorageHelper.getInstance().clear(StorageHelper.keys.inviteCodeTime);
      }
    }
    else {
      this.success = false;
      this.serverError = true;
      this.serverErrorMessage = result && result.message ? result.message : this.getString('registrationFailed');
    }
  }

  handleError(error) {
    Log.getInstance().d(error);
  }

}
